var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('div',{ref:"toolbar",staticClass:"toolbar"}),_c('div',{ref:"editor",staticClass:"textsw"})])
}
var staticRenderFns = []

export { render, staticRenderFns }